import { render, staticRenderFns } from "./ModalButtonFooter.vue?vue&type=template&id=64ee321a&scoped=true"
import script from "./ModalButtonFooter.vue?vue&type=script&lang=js"
export * from "./ModalButtonFooter.vue?vue&type=script&lang=js"
import style0 from "./ModalButtonFooter.vue?vue&type=style&index=0&id=64ee321a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ee321a",
  null
  
)

export default component.exports